import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import axios from "axios";

// v5 (29/09/2026) : le serveur exige desormais la session (bearer) sur des routes
// qui etaient ouvertes (addDevice, sendCoreVersion, RequestdeleteDevice,
// deleteDevice, updateUser, addUserFromSellsy). Plutot que de retoucher chaque
// appel, on ajoute l'en-tete a TOUTE requete vers /Back-end/ du meme site quand
// une session existe et qu'aucun en-tete Authorization n'est deja pose.
// Inoffensif pour l'ancien serveur (qui ignore l'en-tete) : ce front peut donc
// etre publie AVANT le serveur v5.
axios.interceptors.request.use((config) => {
  try {
    const url = config.url || "";
    const memeSite = url.startsWith("/Back-end/") || url.startsWith(window.location.origin + "/Back-end/");
    const deja = config.headers && (config.headers.Authorization || config.headers.authorization);
    if (memeSite && !deja) {
      const u = JSON.parse(sessionStorage.getItem("userData") || "null");
      if (u && u.token) {
        config.headers = config.headers || {};
        if (typeof config.headers.set === "function") config.headers.set("Authorization", `Bearer ${u.token}`);
        else config.headers.Authorization = `Bearer ${u.token}`;
      }
    }
  } catch (e) { /* session illisible : requete envoyee sans en-tete */ }
  return config;
});


// Relecture v5 (A4) : un 401 d'une route /Back-end/ alors qu'une session existait
// signifie que le jeton de session n'est plus valide — il est unique par compte :
// une connexion sur un autre appareil (ordinateur / telephone) remplace le precedent.
// On vide la session et on renvoie vers la connexion avec un message clair, au lieu
// de laisser la page echouer en silence. L'activation Pro connect en attente (QR)
// est conservee : apres reconnexion, retour automatique sur /activer.
axios.interceptors.response.use((r) => r, (error) => {
  try {
    const url = (error.config && error.config.url) || "";
    const memeSite = url.startsWith("/Back-end/") || url.startsWith(window.location.origin + "/Back-end/");
    if (error.response && error.response.status === 401 && memeSite && !/\/Back-end\/loginUser/.test(url)
        && sessionStorage.getItem("userData")) {
      sessionStorage.removeItem("userData");
      const m = (window.location.pathname || "").match(/^\/(fr|en|es)(\/|$)/);
      window.location.assign(`/${m ? m[1] : "fr"}/connexion?session=expiree`);
    }
  } catch (e) { /* rien */ }
  return Promise.reject(error);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

